import classnames from 'classnames'
import { ReactLottiePlayer } from 'scala'
import { animation } from './animation'
import styles from './split-loader.module.scss'

interface SplitLoaderParams {
  className?: string
  size?: 'small' | 'large'
}

export const SplitLoader: React.FC<SplitLoaderParams> = ({
  className,
  size
}) => {
  return (
    <div className={classnames(styles.player, className)}>
      <ReactLottiePlayer
        loop
        autoplay
        src={animation}
        className={classnames(styles.loader, {
          [styles.small]: size === 'small'
        })}
      />
    </div>
  )
}
